import { CommunicationAlertsProvider } from './contexts/CommunicationAlertsContext';
import { PrivilegeProvider } from './components/priviledge/PriviledgeProvider';
import AppRouter from './router';

const App = () => {

  return (
    <PrivilegeProvider>
      <CommunicationAlertsProvider>
        <AppRouter />
      </CommunicationAlertsProvider>
    </PrivilegeProvider>
  );
};

export default App;
